import Box from '@zenbusiness/zui/Box';
import Card from '@zenbusiness/zui/Card';
import CardContent from '@zenbusiness/zui/CardContent';
import { superstyled } from '@zenbusiness/zui/styles';

export const CalloutIconCard = superstyled({
  name: 'CalloutIcon',
  slot: 'Card',
  tag: Card,
  styles: ({ theme }) => ({
    padding: 0, // Remove inherited padding when using nested cards components
    borderWidth: 0.5,
    borderColor: theme.palette.border.main,
    borderRadius: theme.shape.rounded.xl,

    [theme.breakpoints.up('lg')]: {
      borderRadius: theme.shape.rounded['2xl']
    }
  })
});

export const CalloutIconCardContent = superstyled({
  name: 'CalloutIcon',
  slot: 'CardContent',
  tag: CardContent,
  styles: ({ theme }) => ({
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    gap: theme.spacing(2),

    [theme.breakpoints.up('lg')]: {
      gap: theme.spacing(3)
    }
  })
});

export const CalloutIconWrapper = superstyled({
  name: 'CalloutIcon',
  slot: 'Wrapper',
  tag: Box,
  propsNeeded: ['iconBackgroundColor'],
  styles: ({ iconBackgroundColor = 'green', theme }) => ({
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    minWidth: 64,
    minHeight: 64,
    padding: theme.spacing(1),
    backgroundColor: theme.palette.background[iconBackgroundColor].light,
    borderRadius: theme.shape.rounded.md,

    [theme.breakpoints.up('lg')]: {
      borderRadius: theme.shape.rounded.default
    }
  })
});
